/*
 * @Description: 组织API
 * @Autor: xiaona.wang
 * @Date: 2021-12-02 17:10:36
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-12-09 13:47:46
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1/organization`;
const api = {
  // 获取组织树
  getOrgList: (id, params) => request({
    url: `${requestUrl}/${id}`,
    method: "get",
    params
  }),
  // 通过组织id获取组织列表 用于右侧table
  getList: params => request({
    url: `${requestUrl}/page`,
    method: "get",
    params
  }),
  // 级联获取组织
  getCascadeOrgList: id => request({
    url: `${requestUrl}/cascade-org/${id}`,
    method: "get"
  }),
  // 点击组织树查询对应部门信息 v1/organization/page
  getOrgListById: (id, params) => request({
    url: `${requestUrl}/page`,
    method: "get",
    params
  }),
  // 是否有效
  setEffect: data => request({
    url: `${requestUrl}/effect`,
    method: "put",
    data
  }),
  addOrg: data => request({
    url: `${requestUrl}`,
    method: "post",
    data
  }),
  editOrg: data => request({
    url: `${requestUrl}`,
    method: "put",
    data
  }),
  // 根据id查询用户详情
  getDetailsById: params => request({
    url: `${requestUrl}/${params}`,
    method: "get"
  }),

  exportOrg: params => request({
    url: `${requestUrl}/export`,
    responseType: "blob",
    method: "get",
    params
  }),
  // 删除
  deleteItems: params => request({
    url: `${requestUrl}/${params}`,
    method: "delete"
  }),
  syncDepartment: data => request({
    url: `${window.env.scimSystem}/api/v1/tenant/platform/dept`,
    method: "post",
    data
  })
};

export default api;
